"use es6";

import { wrap } from "../../utils/wrap";
import { isEasingArray } from "./is-easing-array";
function getEasingForSegment(easing, i) {
  return isEasingArray(easing) ? easing[wrap(0, easing.length, i)] : easing;
}
export { getEasingForSegment };